import { useEffect, useRef, useState } from 'react';
import { axiosInstance } from '../utils/axios';

export const useAxios = (ssoToken) => {
  const [isInitialized, setInitialized] = useState(false);
  const hasMountedRef = useRef(false);
    
  useEffect(() => {
    const interceptorId = axiosInstance.interceptors.request.use(config => {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${ssoToken}`,
      };
      
      return config;
    });

    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      setInitialized(true);
    }

    return () => axiosInstance.interceptors.request.eject(interceptorId);
  }, [ssoToken, setInitialized]);
    
  return isInitialized;
};